// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEpmMasterAllocationKeysQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ListEpmMasterAllocationKeysQuery = { __typename?: 'Query' } & {
  listEpmMasterAllocationKeys: { __typename?: 'ListEpmMasterAllocationKeys' } & Pick<
    Types.ListEpmMasterAllocationKeys,
    'totalCount'
  > & {
      items: Array<
        { __typename?: 'EpmMasterAllocationKey' } & Pick<
          Types.EpmMasterAllocationKey,
          'id' | 'name' | 'enabled' | 'sortOrder' | 'createdAt' | 'updatedAt'
        > & {
            usageStats: { __typename?: 'EpmMasterSimpleUsageStats' } & Pick<
              Types.EpmMasterSimpleUsageStats,
              'employeeAllocationCount'
            >;
          }
      >;
    };
};

export const ListEpmMasterAllocationKeysDocument = /*#__PURE__*/ gql`
    query listEpmMasterAllocationKeys($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String) {
  listEpmMasterAllocationKeys(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword}
  ) {
    items {
      id
      name
      enabled
      sortOrder
      createdAt
      updatedAt
      usageStats {
        employeeAllocationCount
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListEpmMasterAllocationKeysQuery__
 *
 * To run a query within a React component, call `useListEpmMasterAllocationKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEpmMasterAllocationKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEpmMasterAllocationKeysQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useListEpmMasterAllocationKeysQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>(
    ListEpmMasterAllocationKeysDocument,
    options,
  );
}
export function useListEpmMasterAllocationKeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEpmMasterAllocationKeysQuery,
    ListEpmMasterAllocationKeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>(
    ListEpmMasterAllocationKeysDocument,
    options,
  );
}
// @ts-expect-error
export function useListEpmMasterAllocationKeysSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEpmMasterAllocationKeysQuery,
    ListEpmMasterAllocationKeysQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>;
export function useListEpmMasterAllocationKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListEpmMasterAllocationKeysQuery | undefined,
  ListEpmMasterAllocationKeysQueryVariables
>;
export function useListEpmMasterAllocationKeysSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEpmMasterAllocationKeysQuery, ListEpmMasterAllocationKeysQueryVariables>(
    ListEpmMasterAllocationKeysDocument,
    options,
  );
}
export type ListEpmMasterAllocationKeysQueryHookResult = ReturnType<typeof useListEpmMasterAllocationKeysQuery>;
export type ListEpmMasterAllocationKeysLazyQueryHookResult = ReturnType<typeof useListEpmMasterAllocationKeysLazyQuery>;
export type ListEpmMasterAllocationKeysSuspenseQueryHookResult = ReturnType<
  typeof useListEpmMasterAllocationKeysSuspenseQuery
>;
